var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6801 2.56H8.32006C5.14438 2.56 2.56006 5.14368 2.56006 8.32V23.68C2.56006 26.8563 5.14438 29.44 8.32006 29.44H23.6801C26.8557 29.44 29.4401 26.8563 29.4401 23.68V8.32C29.4401 5.14368 26.8557 2.56 23.6801 2.56ZM22.4001 17.28V19.84V19.8534H22.3988C22.3911 21.6115 20.9594 23.04 19.2001 23.04H18.8801C18.2484 23.04 17.6429 22.7712 17.2186 22.3027C16.7949 21.8349 16.5882 21.2032 16.6509 20.5715C16.7649 19.4432 17.7837 18.56 18.9716 18.56H19.8401C20.546 18.56 21.1201 17.9859 21.1201 17.28V11.0112L13.4401 12.4512V19.2V21.76C13.4401 23.5245 12.0045 24.96 10.2401 24.96H9.92006C9.28838 24.96 8.68294 24.6912 8.25862 24.2227C7.83494 23.7549 7.62822 23.1232 7.69094 22.4915C7.80486 21.3632 8.82374 20.48 10.0116 20.48H10.8801C11.586 20.48 12.1601 19.9059 12.1601 19.2V9.82592C12.1601 9.2096 12.5997 8.68032 13.2052 8.56768L21.2634 7.05728C21.5444 7.00416 21.8337 7.0784 22.0532 7.26144C22.274 7.44448 22.4001 7.71392 22.4001 8V17.28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/Apple_music.cc265638c05e8feb6de6cc597e20f232.svg";
export { ForwardRef as ReactComponent };